import React from 'react';
import { Row, Col, Panel, Modal, Button, ButtonToolbar, SplitButton, MenuItem } from 'react-bootstrap';
import { fetchApi } from '../../Network/NetworkService';
import { notif } from '../Ui/Notification';
import dateFormat from 'dateformat';
import isoDate from '../../Services/toIsoDate.js';

import IconTooltip from '../Ui/IconTooltip';
import Swal from 'sweetalert2';
import debounce from '../../Services/debounce.js';
import { SEARCH_DEBOUNCE_MS, isSearchable } from '../../Services/searchInput.js';
import { exportAsExcel } from '../../Services/exportAsExcel';
import { PhoneFlag, ILFlag, PoolFlag, countryFromPhone, marketOfUser } from '../../Services/phoneCountry';

import UserCounter from '../Ui/UserCounter';
import moment from 'moment';

export default class Users extends React.Component {
    constructor() {
        super();

        this.state = {
            users: [],
            totalPage: 0,
            input: '',
            page: 1,
            month: null,
            type: { value: 'all', label: 'Tous' },
            numberR:  { value: 'all', label: 'Tous' },
            country: { value: 'all', label: 'Tous pays' },
            countUsers: 0,
            loading: false,
            isExporting: false,
            selectedState: [],
            dateRange: null,
            filterStartDate: new Date().toISOString().split('T')[0],
            filterEndDate: new Date().toISOString().split('T')[0],
            showFilterModal: false,
            filterModalOption: 'tous'
        };


        this.handleRemove = this.handleRemove.bind(this);
        this.onSort = this.onSort.bind(this);
        this.sortInt = this.sortInt.bind(this);
        this.getUsers = this.getUsers.bind(this);
        this.filterModal = this.filterModal.bind(this);

        // Checked when the timer fires, so a quick backspace to 1–2 characters cancels it.
        this.debounceGetUser = debounce(() => { if (isSearchable(this.state.input)) this.getUsers(); }, SEARCH_DEBOUNCE_MS);
    }

    getUsers() {
        this.setState({ loading: true });

        const searchInput = this.state.input.length === 0 ? '' : this.state.input[0] === '0' || this.state.input[0] === '+' ? this.state.input.substring(1, this.state.input.length) : this.state.input;
   
        fetchApi(`/users?page=${this.state.page}${this.state.input.trim() ? `&search=${encodeURIComponent(searchInput)}` : ''}${this.state.dateRange ? `&start=${isoDate(this.state.dateRange[0], 0, 1)}` : ''}${this.state.dateRange ? `&end=${isoDate(this.state.dateRange[1], 23, 59, 59)}`: ''}${this.state.numberR.value ? `&numberR=${this.state.numberR.value}` : ''}${this.state.country && this.state.country.value && this.state.country.value !== 'all' ? `&country=${this.state.country.value}` : ''}`)
            .then((res) =>
                    this.setState({ users: res.users, totalPage: res.countPages, loading: false, countUsers: res.countUsers })
            )
            .catch((err) =>
                notif.addNotification(
                    'Erreur',
                    'Erreur de recuperation des donnees Utilisateur: ' + err,
                    'warning'
                )
            );
    }

    componentDidMount() {
        this.getUsers();
    }

    updatePage(page) {
        this.setState({ users: [], page, loading: true }, () => {
            this.getUsers()
        });
    }

    sortInt(sortKey, sortSecond) {
        const users = this.state.users;

        if (this.state.sort) {
            users.sort((a, b) => a[sortKey][sortSecond] - b[sortKey][sortSecond]);
        } else {
            users.sort((a, b) => b[sortKey][sortSecond] - a[sortKey][sortSecond]);
        }

        this.setState({ users: users, sort: !this.state.sort });
    }

    onSort(sortKey, sortSecond) {
        if (sortSecond) {
            const users = this.state.users;

            if (this.state.sort) {
                users.sort((a, b) =>
                    a[sortKey][sortSecond].localeCompare(b[sortKey][sortSecond])
                );
            } else {
                users.sort((a, b) =>
                    b[sortKey][sortSecond].localeCompare(a[sortKey][sortSecond])
                );
            }
        } else {
            const data = this.state.users;
            if (this.state.sort) {
                data.sort((a, b) => a[sortKey].localeCompare(b[sortKey]));
                this.setState({ sort: false });
            } else {
                data.sort((a, b) => b[sortKey].localeCompare(a[sortKey]));
                this.setState({ sort: true });
            }
            this.setState({ users: data });
        }
    }

    handleRemove(id) {
        const user = this.state.users.find(({ _id }) => _id === id);

        const swalWithBootstrapButtons = Swal.mixin({
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            buttonsStyling: false
        });

        swalWithBootstrapButtons({
            title: 'Cette action est reversible',
            text: ``,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, supprimer!',
            cancelButtonText: 'Non, annuler!',
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                fetchApi('/users', {
                    method: 'DELETE',
                    body: JSON.stringify({
                        id: user._id
                    })
                }).then(() => {
                    this.getUsers()
                    swalWithBootstrapButtons(
                        'Supprime!',
                        'Utilisateur supprime',
                        'success'
                    );
                });
            }
        });
    }

    exportToExcel() {
        this.setState({ isExporting: true }, () => {
            fetchApi(`/requests/users/getMail`, {
            method: 'POST',
            body: JSON.stringify({
                start: isoDate(this.state.filterStartDate, 0, 1),
                end: isoDate(this.state.filterEndDate, 23, 59, 59),
                type: this.state.selectedState,
                option: this.state.filterModalOption,
                country: this.state.country && this.state.country.value
            })
        })
            .then((res) => {
                let clsRec = [
                    { wch: 10 },
                    { wch: 30 },
                    { wch: 25 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 },
                ]

                const toExport = res.data.map((v, idx) => {
                    if (this.state.filterModalOption === 'recurrent') {
                        const d = {
                            '№': idx + 1,
                            'Email': v.email,
                            'Nom et prenom': `${v.FName} ${v.LName}`,
                            "Date d'inscription" : moment(v.createdAt).format('DD/MM/YYYY hh:mm'),
                            'Montant dépensé': v.totalAmount,
                            'Nb de tlc': v.request.length,
                        }
                        
                        for (let i = 0; i < v.request.length; i++) {
                            d[`${i+1}${i+1 === 1 ? 'er' : 'eme'} tlc`] = moment(v.request[i].createdAt).format('DD/MM/YYYY hh:mm')
                            clsRec.push({ wch: 15 });
                        }



                        
                        return d
                    }


                    return {
                        'Nom et prenom': `${v.FName} ${v.LName}`,
                        'Email': v.email,
                        'Téléphone': v.phone, 
                        "Date d'inscription": new Date(v.createdAt).toLocaleDateString(),
                        "Récurrence" : (v.request && v.request.length >  0) ? v.request.length : "Non",
                        "Type de demande" : [...new Set(v.request?.map(el => el.type))].toString() || ''
                    }
                });                
                
                const cls = this.state.filterModalOption === 'recurrent' ? clsRec : [
                    { wch: 25 },
                    { wch: 30 },
                    { wch: 30 },
                    { wch: 20 },
                    { wch: 13 },
                    { wch: 30 },
                ]

                this.setState({ isExporting: false, showFilterModal: false, selectedState: [] }, () => {
                    notif.addNotification(
                        'Succes !',
                        '',
                        'success'
                    )
                    exportAsExcel(toExport, `emails_${new Date().toISOString()}`, cls);
                    clsRec = [
                        { wch: 10 },
                        { wch: 30 },
                        { wch: 25 },
                        { wch: 15 },
                        { wch: 15 },
                        { wch: 15 },
                    ]
                } );
            })
            .catch((err) => {
                this.setState({ isExporting: false, showFilterModal: false }, () => {
                    notif.addNotification(
                        'Erreur',
                        err,
                        'warning'
                    );
                });
            });
        });
    }


    filterModal() {

        return (
            <Modal show={this.state.showFilterModal}>
                <Modal.Header>
                    <Modal.Title>Filtre</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ paddingBottom: 10 }}>
                        <ButtonToolbar>
                            <SplitButton
                                id="option-list"
                                rootCloseEvent="mousedown"
                                title={this.state.filterModalOption}
                            >   
                                {
                                    ['tous', 'recurrent'].map((v) => (
                                        <MenuItem
                                            eventKey={v}
                                            active={v === this.state.filterModalOption}
                                            onSelect={v === this.state.filterModalOption ? undefined : () => { this.setState({ filterModalOption: v }) }}
                                            key={v}
                                        >
                                            {v}
                                        </MenuItem>
                                    ))
                                }
                            </SplitButton>
                        </ButtonToolbar>
                    </div>
                    <div>
                        De : <input 
                                type="date" 
                                value={this.state.filterStartDate} 
                                onChange={(e) => this.setState({ filterStartDate: e.target.value })} 
                                max={this.state.filterEndDate || new Date().toISOString().split('T')[0]}
                            />
                    </div>
                    <div style={{ margin: '20px 0' }}>
                       au : <input 
                                type="date" 
                                value={this.state.filterEndDate} 
                                onChange={(e) => this.setState({ filterEndDate: e.target.value })} 
                                min={this.state.filterStartDate}
                            />
                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={() => this.setState({ showFilterModal: false, selectedState: [] })}>Fermer</Button>
                    <Button disabled={this.state.isExporting} onClick={() => this.exportToExcel()} bsStyle="primary">{this.state.isExporting ? 'Chargement ...' : 'Valider'}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        if (!this.state.users) {
            return <div>Récupération des données en cours...</div>;
        }
        const page = this.state.page;

        return (
            <div className="pT-25">
                {this.filterModal()}
                <Row>
                    <Col md={12}>
                        <UserCounter
                            isPartner={this.props.role === 4} 
                            utm_source={this.props.utm_source}
                            dateRange={this.state.dateRange}
                            setDate={(v) => this.setState({ dateRange: v }, () => {
                                this.getUsers();
                            })}
                            setMonth={(val) => this.setState({ month: val, page: 1 }, () => {
                                this.getUsers();
                            })}
                            typeOption={this.state.type}
                            setTypeOption={(val) => this.setState({ type: val, page: 1 }, () => {
                                this.getUsers();
                            })}
                            numberRequest={this.state.numberR}
                            setNumberRequest={(val) => this.setState({ numberR: val, page: 1 }, () => {
                                this.getUsers();
                            })}
                            country={this.state.country}
                            setCountry={(val) => this.setState({ country: val, page: 1 }, () => {
                                this.getUsers();
                            })}
                            loading={this.state.loading}
                            count={this.state.countUsers}
                        />

                        <Panel>
                            <Panel.Heading>
                                <h6>Utilisateurs</h6>
                            </Panel.Heading>
                            <Panel.Body>
                                <div>
                                    <div style={{ margin: '10px 0' }}>
                                        <button 
                                            className="button-export" 
                                            onClick={() => this.setState({ showFilterModal: true })}
                                            disabled={this.state.showFilterModal}
                                        >
                                            Exporter les emails en excel
                                        </button>
                                    </div>
                                    
                                    <div>
                                        <input
                                            type="text"
                                            className={'input-search'}
                                            placeholder="Taper le nom, le prénom, le mail ou le numéro téléphone d'un client"
                                            value={this.state.input}
                                            onChange={(e) => {
                                                this.setState({ input: e.target.value, page: 1 }, () => {
                                                    this.debounceGetUser();
                                                });
                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', gap: 15, marginTop: 10 }}>

                                        <p>
                                        Liste des utilisateurs (Page <strong>{page}</strong> /{' '}
                                            {this.state.totalPage})
                                        </p>

                                        <div>
                                            {page > 1 && (
                                                <IconTooltip
                                                    icon="fa fa-chevron-left"
                                                    text="Page précédente"
                                                    onClick={() => this.updatePage(page - 1)}
                                                />
                                            )}
                                            {page < this.state.totalPage && (
                                                <IconTooltip
                                                    icon="fa fa-chevron-right"
                                                    text="Page suivante"
                                                    onClick={() => this.updatePage(page + 1)}
                                                />
                                            )}
                                        </div>

                                    </div>
                                </div>
                                <div className="mT-40" />
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('FName')}
                                                >
                          Utilisateur
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('createdAt')}
                                                >
                          Date d'inscription
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('lastLoginDate')}
                                                >
                          Dernière connexion
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.sortInt('request', 'length')}
                                                >
                          Requetes
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('ab_variant')}
                                                >
                          A/B Variant
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.users.map((d) => (
                                                <tr key={d._id}>
                                                    <td>
                                                        {d.FName} {d.LName}
                                                        {d.phone && (
                                                            <span
                                                                title={d.phone}
                                                                style={{ marginLeft: 6 }}
                                                            >
                                                                <PhoneFlag phone={d.phone} />
                                                            </span>
                                                        )}
                                                        {d.isIL && countryFromPhone(d.phone) !== 'IL' && (
                                                            <ILFlag title="Patient Israël (IL)" />
                                                        )}
                                                        {/* Same reason as the IL flag above: the market was
                                                            DECLARED, so the phone flag beside it does not show
                                                            it. Without this a filtered Espagne list is full of
                                                            🇫🇷 rows with nothing saying why they matched. */}
                                                        {marketOfUser(d) === 'ES' && countryFromPhone(d.phone) !== 'ES' && (
                                                            <PoolFlag pool="ES" label="Patient Espagne (ES)" />
                                                        )}
                                                    </td>
                                                    <td>{dateFormat(d.createdAt, 'dd/mm/yy HH:MM')}</td>
                                                    <td>
                                                        {dateFormat(d.lastLoginDate, 'dd/mm/yy HH:MM')}
                                                    </td>
                                                    <td>{d.request.length}</td>
                                                    <td>{d.ab_variant || 'v1'}</td>
                                                    <td>
                                                        <IconTooltip
                                                            icon="fa fa-user"
                                                            text="Voir le profil"
                                                            onClick={() =>
                                                                this.props.history.push(
                                                                    '/users/detail/' + d._id
                                                                )
                                                            }
                                                        />
                                                        {!d.deleted && (
                                                            <IconTooltip
                                                                icon="fa fa-close danger"
                                                                text="Supprimer"
                                                                onClick={() => this.handleRemove(d._id)}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </div>
        );
    }
}
